"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleCard = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var constants_1 = require("../../constants");
var sx = {
    title: {
        fontSize: 14,
        fontWeight: 400,
    },
    listItemText: {
        margin: 0,
    },
};
var ModuleCard = function (props) {
    var label = props.label, link = props.link, listItemSx = props.listItemSx;
    var primaryTypographyProps = {
        sx: sx.title,
    };
    return (react_1.default.createElement(material_1.ListItemButton, { component: "a", href: link, sx: listItemSx, "data-testid": constants_1.ModularNavigationWidgetTestIds.moduleCardLabel },
        react_1.default.createElement(material_1.ListItemText, { primaryTypographyProps: primaryTypographyProps, sx: sx.listItemText }, label)));
};
exports.ModuleCard = ModuleCard;
